import React from "react";
import { Box } from "@mui/material";
import { BankAccount } from "src/store/features/withdrawal.slice";
import { HoldingRes } from "src/store/features/api/generated";
import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";
import {
  StyledContainer,
  StyledItem,
  StyledValue,
  ReviewSectionTitle,
} from "../common/styles/FiatWithdrawalStyled";
import CompletedIcon from "src/icons/portfolio/CompletedIcon";
import { useHistory } from "react-router-dom";

interface FiatWithdrawalStageCompletedProps {
  selectedBankAccount: BankAccount | null;
  withdrawalAmount: number;
  bankAccounts: BankAccount[];
  defaultCurrencyHolding?: HoldingRes;
}

export function FiatWithdrawalStageCompleted({
  selectedBankAccount,
  withdrawalAmount,
  bankAccounts,
  defaultCurrencyHolding,
}: FiatWithdrawalStageCompletedProps) {
  const history = useHistory();

  const handleViewTransactions = () => {
    history.push("/transactions");
  };

  return (
    <StyledContainer>
      {/* Styled warning box at the top */}

      <Box
        component="div"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          background: "#F0FEF9",
          borderRadius: "16px",
          padding: "8px",
          marginBottom: "28px",
          boxShadow: "none",
        }}>
        <Box component="div" sx={{ display: "flex", alignItems: "center" }}>
          <CompletedIcon tooltip={""} />
          <Box
            component="div"
            sx={{ fontWeight: 600, color: "#002035", fontSize: "14px", paddingLeft: "5px" }}>
            Withdrawal Request Submitted
          </Box>
        </Box>
        <Box
          component="div"
          sx={{ color: "#002035", fontWeight: 400, fontSize: "14px", textAlign: "left" }}>
          Your withdrawal request has been submitted successfully. You will receive a confirmation
          email shortly.
        </Box>{" "}
      </Box>

      {/* Bank account section */}
      <StyledItem sx={{ flexDirection: "column", alignItems: "flex-start", margin: 0 }}>
        <ReviewSectionTitle>Bank account</ReviewSectionTitle>
        <Box display="flex" alignItems="center" style={{ paddingBottom: "28px" }}>
          <CountryOrCryptoFlag name={selectedBankAccount?.currency || ""} size={16} />
          <StyledValue>
            {selectedBankAccount
              ? `${
                  selectedBankAccount.currency
                } - Account ending in ${selectedBankAccount.accountNumber?.slice(-4)}`
              : "Not selected"}
          </StyledValue>
        </Box>
      </StyledItem>

      {/* Amount section */}
      <StyledItem sx={{ flexDirection: "column", alignItems: "flex-start", margin: 0 }}>
        <ReviewSectionTitle>Amount to Withdraw</ReviewSectionTitle>
        <Box display="flex" alignItems="center" style={{ paddingBottom: "28px" }}>
          <CountryOrCryptoFlag name={selectedBankAccount?.currency || ""} size={16} />
          <StyledValue>
            {withdrawalAmount} {selectedBankAccount?.currency ?? ""}
          </StyledValue>
        </Box>
      </StyledItem>
    </StyledContainer>
  );
}
